module.exports = __webpack_public_path__ + "static/media/bikeNew.8269754b.svg";